'use client';

import myorders from '@/assets/images/convention/faq/Myorders.svg';
import payment from '@/assets/images/convention/faq/Payment.svg';
import products from '@/assets/images/convention/faq/Products.svg';
import promotion from '@/assets/images/convention/faq/Promotion.svg';
import returns from '@/assets/images/convention/faq/Returns&Refund.svg';
import shipping from '@/assets/images/convention/faq/Shipping&Delivery.svg';
import headerbanner from '@/assets/images/convention/faq/faqbanner.jpg';
import Button from '@/components/Button';
import useIsMobile from '@/hooks/use-is-mobile';
import { AutoComplete, Tabs } from 'antd';
import clsx from 'clsx';
import Image from 'next/image';
import { useCallback, useEffect, useState } from 'react';
import classes from './faqPage.module.css';

const FaqPage = ({ options }) => {
  const isMobile = useIsMobile();
  const pageTitle = 'Help & FAQs';
  const pageSubTitle = 'We are here to help you!';

  const [optiondata, setOptiondata] = useState([...options]);
  const [qaStatus, setQAStatus] = useState(
    options.map(item => {
      return {
        q: item.value,
        s: false,
      };
    }),
  );
  const [keyWord, setKeyWord] = useState('');

  const [tabsctiveKey, setTabsActiveKey] = useState('0');

  const [qtypeArray, setQtypeArray] = useState([]);
  const TitleIndexMap = new Map([
    ['SHIPPING & DELIVERY', 0],
    ['RETURNS & REFUND', 1],
    ['PAYMENT', 2],
    ['PRODUCTS', 3],
    ['MY ORDERS', 4],
    ['PROMOTION', 5],
  ]);
  const setOpen = useCallback(q => {
    q = clearmarkhtml(q);
    const currentobj = qaStatus.filter(item => item.q == q)[0];
    const otherobj = qaStatus.filter(item => item.q != q);

    if (currentobj.s) {
      currentobj.s = false;
    } else {
      currentobj.s = true;
      otherobj.map(item => {
        item.s = false;
      });
    }

    setQAStatus([...qaStatus]);
  }, []);

  const onSelect = function (v, o) {
    setOpen(v);

    if (!isMobile) {
      if (o.qtype == 'PRODUCTS' || o.qtype == 'MY ORDERS' || o.qtype == 'PROMOTION') {
        window.scrollTo(0, 1300);
      } else {
        window.scrollTo(0, 450);
      }
    } else {
      setTabsActiveKey(TitleIndexMap.get(o.qtype).toString());
      window.scrollTo(0, 250);
    }
  };

  const onChange = function (v) {
    setKeyWord(v);
  };

  const clearmarkhtml = function (keyWord) {
    return keyWord
      ?.replace(new RegExp('<span style="background-color:#81573F;color:#fff">', 'g'), '')
      .replace(new RegExp('</span>', 'g'), '');
  };

  const onChangeTab = function (key) {
    setTabsActiveKey(key);
  };

  const markKeyWord = useCallback(() => {
    optiondata.map(item => {
      item.value = clearmarkhtml(item.value);
      const ofindex = item.value.toLocaleLowerCase().indexOf(keyWord.toLocaleLowerCase());

      if (item.value.toLocaleLowerCase() == keyWord.toLocaleLowerCase()) {
        item.value = '<span style="background-color:#81573F;color:#fff">' + item.value + '</span>';
      } else {
        if (ofindex > -1) {
          if (isMobile) {
            if (!qtypeArray.includes(item.qtype)) {
              qtypeArray.push(item.qtype);
              setQtypeArray([...qtypeArray]);
            }

            if (qtypeArray.length) {
              setTabsActiveKey(TitleIndexMap.get(qtypeArray[0]).toString());
            }
          }

          item.value = item.value.replace(
            new RegExp(item.value.substring(ofindex, ofindex + keyWord.length), 'g'),
            '<span style="background-color:#81573F;color:#fff">' +
              item.value.substring(ofindex, ofindex + keyWord.length) +
              '</span>',
          );
        } else {
          item.value = item.value.replace(
            new RegExp(keyWord, 'g'),
            '<span style="background-color:#81573F;color:#fff">' + keyWord + '</span>',
          );
        }
      }
    });
    setOptiondata([...optiondata]);
    setQtypeArray([]);
  }, [keyWord]);

  function QAitem(v) {
    v = v.v;

    return (
      <li
        className={classes.qaitem}
        onClick={() => setOpen(v.value)}
      >
        <p
          className={[
            classes.q,
            qaStatus.filter(qitem => qitem.q == clearmarkhtml(v.value)).length > 0 &&
            qaStatus.filter(qitem => qitem.q == clearmarkhtml(v.value))[0]?.s
              ? classes.qctive
              : null,
          ].join(' ')}
          dangerouslySetInnerHTML={toHTML(v.value)}
        />
        {qaStatus.filter(qitem => qitem.q == clearmarkhtml(v.value)).length > 0 &&
        qaStatus.filter(qitem => qitem.q == clearmarkhtml(v.value))[0]?.s ? (
          <div
            className={classes.a}
            dangerouslySetInnerHTML={toHTML(v.answer)}
          />
        ) : null}
      </li>
    );
  }

  const questiontype = [
    {
      title: 'SHIPPING & DELIVERY',
      img: shipping,
    },
    {
      title: 'RETURNS & REFUND',
      img: returns,
    },
    {
      title: 'PAYMENT',
      img: payment,
    },
    {
      title: 'PRODUCTS',
      img: products,
    },
    {
      title: 'MY ORDERS',
      img: myorders,
    },
    {
      title: 'PROMOTION',
      img: promotion,
    },
  ];
  const toHTML = str => ({
    __html: str,
  });

  const itemlist = questiontype.map((item, index) => (
    <div
      key={index}
      className={classes.item}
    >
      <h1 className={classes.itemtitle}>
        <Image
          className={classes.itemtitleicon}
          src={item.img}
          alt=''
        />
        {item.title}
      </h1>
      <ul className={classes.itemcon}>
        {optiondata
          .filter(qaitem => qaitem.qtype == item.title)
          .map((v, i) => (
            <QAitem
              v={v}
              key={i}
            />
          ))}
      </ul>
    </div>
  ));

  const itemlist_m = (
    <div className={classes.item}>
      <Tabs
        activeKey={tabsctiveKey}
        tabPosition='top'
        onChange={onChangeTab}
        items={questiontype.map((_, i) => {
          const id = String(i);

          return {
            label: _.title,
            key: id,
            children: (
              <ul className={classes.itemcon}>
                {optiondata
                  .filter(qaitem => qaitem.qtype == _.title)
                  .map((v, i) => (
                    <QAitem
                      v={v}
                      key={i}
                    />
                  ))}
              </ul>
            ),
          };
        })}
      />
    </div>
  );

  useEffect(() => {
    document.onkeydown = function (e) {
      // 兼容FF和IE和Opera
      const theEvent = window.event || e;
      const code = theEvent.keyCode || theEvent.which || theEvent.charCode;

      if (code == 13) {
        markKeyWord();
      }
    };
  }, [markKeyWord]);

  return (
    <div className={[classes.root, classes.faq].join(' ')}>
      {isMobile ? (
        <h1 className={classes.title}>{pageTitle}</h1>
      ) : (
        <Image
          src={headerbanner}
          alt=''
        />
      )}
      <h1 className={classes.subtitle}>{pageSubTitle}</h1>
      <div className={classes.searchcon}>
        <div
          className={clsx(
            'border-y-1 border-l-1  border-solid',
            '[&_.ant-select-selection-search-input]_text-[15px]',
            '[&_.ant-select-selection-search-input]_placeholder_text-[15px]',
          )}
        >
          <AutoComplete
            style={{
              width: isMobile ? 'auto' : 500,
              height: isMobile ? 50 : 60,
            }}
            options={options}
            onSelect={onSelect}
            onChange={onChange}
            allowClear
            placeholder='try to type "shipping"'
            filterOption={(inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            popupClassName='faq-popup'
          />
        </div>
        <Button
          className='group aw-primary-btn flex h-[52px] w-[100px] items-center justify-center rounded-[3px] lg_h-[62px] lg_w-24'
          id='searchBtn'
          onClick={markKeyWord}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='77'
            height='76'
            fill='none'
            viewBox='0 0 77 76'
            className='h-auto w-[30px]'
          >
            <path
              className='fill-white lg_group-hover_fill-80583F'
              d='M76 71.3 58.8 54.1c11.7-13.8 10-34.6-3.8-46.3s-34.6-10-46.3 3.8-10 34.6 3.8 46.3c12.3 10.4 30.3 10.4 42.5-.1L72.2 75c1.1 1 2.8.9 3.7-.1 1.1-1 1.1-2.6.1-3.6M33.8 60.6c-15.4 0-27.9-12.5-27.9-27.9S18.4 4.8 33.8 4.8s27.9 12.5 27.9 27.9c0 15.5-12.5 27.9-27.9 27.9'
            />
          </svg>
        </Button>
      </div>
      <div className={classes.qalist}>{isMobile ? itemlist_m : itemlist}</div>
    </div>
  );
};

export default FaqPage;
